import Vue from 'vue';

const TIMER_ID = Symbol('@@TIMER_ID');
const HIDDEN_VALUE = Symbol('@@HIDDEN_VALUE');

export default (emmiterName, duration = 400) => ({
  data() {
    return {
      [TIMER_ID]: null,
      [HIDDEN_VALUE]: null,
    };
  },
  computed: {
    actualValue() {
      return this[HIDDEN_VALUE] || this.value;
    },
  },
  methods: {
    onAsyncInputChange(event) {
      clearTimeout(this[TIMER_ID]);
      Vue.set(this, HIDDEN_VALUE, event.target.value);
      this[TIMER_ID] = setTimeout(() => this[emmiterName](event), duration);
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/AsyncInput.js